import { render } from "./Report.vue?vue&type=template&id=6adf7510&scoped=true&ts=true"
import script from "./Report.vue?vue&type=script&lang=ts"
export * from "./Report.vue?vue&type=script&lang=ts"

import "./Report.vue?vue&type=style&index=0&id=6adf7510&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adf7510"]])

export default __exports__